module.exports = __webpack_public_path__ + "img/knu2_gallery8.545eda0f.jpg";